var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.stops)?_c('GmapMap',{ref:"mapRef",staticClass:"mapStyle overflow-hidden border-radius-regular w-full",attrs:{"center":_vm.center,"zoom":7,"options":_vm.options}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }